<template>
  <div class="card mb-6">
     <div class="card-body pt-9 pb-0">
       <div class="d-flex flex-wrap flex-sm-nowrap">
         <div class="me-7 mb-4 pt-6 m-4">
           <img :src="company?.society?.logo_url" alt="image"  height="100" width="100" style="object-fit: contain;" />
         </div>
         <div class="flex-grow-1">
           <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
             <div class="d-flex flex-column">
               <div class="d-flex align-items-center mb-2">
                     <span class="text-gray-900 fs-2 fw-bolder me-1">
                       {{ company?.society?.name }}
                     </span>
               </div>
               <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                 <span class="d-flex align-items-center text-primary me-5 mb-2">
                       <span class="svg-icon svg-icon-4 me-1 text-black">
 
                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                           <path opacity="0.3"
                                 d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                                 fill="currentColor"></path>
                           <path
                               d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                               fill="currentColor"></path>
                         </svg>
                       </span>
                       {{ company?.society?.address }}
                     </span>
                 <span class="d-flex align-items-center text-primary mb-2">
                       <span class="svg-icon svg-icon-4 me-1 text-black">
                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                           <path opacity="0.3"
                                 d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                                 fill="currentColor"></path>
                           <path
                               d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                               fill="currentColor"></path>
                         </svg>
                       </span>
                   {{ company?.society?.society_email }}
                 </span>
               </div>
             </div>
           </div>
           <div class="d-flex flex-wrap flex-stack">
             <div class="d-flex flex-column flex-grow-1 pe-8">
               <div class="d-flex flex-wrap">
                 <router-link v-if="$can(abilities.VIEW_PRODUCT)" to="/admin/items" class="border border-primary border-dashed rounded min-w-150px py-3 px-4 me-6 mb-3">
                   <div class="fw-bold fs-6 text-gray-400">{{ $t('company.product') }}</div>
                   <div class="d-flex align-items-center">
                     <div class="fs-2 fw-bolder counted" data-kt-countup="true">
                       {{ company?.statistics?.total_products}}
                     </div>
                   </div>
                 </router-link>
                 <router-link v-if="$can(abilities.VIEW_CONTACT)" to="/admin/contacts" class="border border-primary border-dashed rounded min-w-150px py-3 px-4 me-6 mb-3">
                   <div class="fw-bold fs-6 text-gray-400">{{ $t('company.customer') }}</div>
                   <div class="d-flex align-items-center">
                     <div class="fs-2 fw-bolder counted" data-kt-countup="true">
                       {{ company?.statistics?.total_clients}}
                     </div>
                   </div>
                 </router-link>
                 <router-link v-if="$can(abilities.VIEW_USER)" to="/admin/settings-user/users" class="border border-primary border-dashed rounded min-w-150px py-3 px-4 me-6 mb-3">
                   <div class="fw-bold fs-6 text-gray-400">{{ $t('company.employee') }}</div>
                   <div class="d-flex align-items-center">
                     <div class="fs-2 fw-bolder counted" data-kt-countup="true">
                       {{ company?.statistics?.total_users}}
                     </div>
                   </div>
                 </router-link>
               </div>
             </div>
           </div>
         </div>
       </div>
       <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder" role="tablist">
         <li class="nav-item mt-2" role="information">
               <span role="tab" aria-selected="true" class="cursor-pointer nav-link text-active-primary ms-0 me-10 py-5" @click="changeSection(1)"
                     :class="section == 1 ? 'active' : ''">
                 {{ $t('company.label.generalInformation') }}
               </span>
         </li>
         <li class="nav-item mt-2" role="responsable">
               <span role="tab" class="cursor-pointer nav-link text-active-primary ms-0 me-10 py-5" @click="changeSection(2)"
                     :class="section == 2 ? 'active' : ''">
                 {{ $t('company.label.responsableInformation') }}
               </span>
         </li>
         <li class="nav-item mt-2" role="bank">
               <span role="tab" class="cursor-pointer nav-link text-active-primary ms-0 me-10 py-5" @click="changeSection(3)"
                     :class="section == 3 ? 'active' : ''">
                 {{ $t('company.label.bankInformation') }}
               </span>
         </li>
         <li class="nav-item mt-2"information role="location">
               <span role="tab" class="cursor-pointer nav-link text-active-primary ms-0 me-10 py-5" @click="changeSection(4)"
                     :class="section == 4 ? 'active' : ''">
                 {{ $t('company.label.location') }}
               </span>
         </li>
       </ul>
     </div>
   </div>
 
   <div id="kt_content" class="card" v-show="section == 1">
     <div class="card-toolbar mt-8 me-5 text-end">
       <div class="card-toolbar mt-8 me-5 text-end">
         <Button btn-class="btn-sm" v-if="$can(abilities.UPDATE_COMPANY)" type="new" btn-text="company.modifier" @click="toggleEditCompanyInfoForm"/>
       </div>
     </div>
     <div class="card card-flush mb-5 mb-lg-10" data-kt-subscriptions-form="pricing">
       <div class="row fs-6 p-5">
         <div class="col-12 col-md-6 col-lg-6 mb-5">
           <div class="card shadow-sm" style="min-height: 230px;">
             <div class="d-flex flex-wrap py-5">
               <div class="flex-equal">
                 <table class="table fs-6 fw-bold gs-0 gy-2 m-0">
                   <tbody>
                     <tr style="border-bottom: 1px solid #CCCFD3;">
                       <td class="px-5 text-gray-400">{{ $t('company.label.name') }}</td>
                       <td class="text-gray-800 text-end pe-5">
                         <span class="text-gray-800 text-hover-primary">{{ company?.society?.name }}</span>
                       </td>
                     </tr>
                     <tr style="border-bottom: 1px solid #CCCFD3;">
                       <td class="px-5 text-gray-400">{{ $t('company.label.email') }}</td>
                       <td class="text-gray-800 text-end pe-5">
                         <span class="text-gray-800 text-hover-primary">{{ company?.society?.society_email }}</span>
                       </td>
                     </tr>
                     <tr style="border-bottom: 1px solid #CCCFD3;">
                       <td class="px-5 text-gray-400">{{ $t('company.label.phone') }}</td>
                       <td class="text-gray-800 text-end pe-5">
                         <span v-if="company?.society?.phone" class="text-gray-800 text-hover-primary">{{ company?.society?.phone_code }} {{ company?.society?.phone}}</span>
                       </td>
                     </tr>
                     <tr style="border-bottom: 1px solid #CCCFD3;">
                       <td class="px-5 text-gray-400">{{ $t('company.label.country') }}</td>
                       <td class="text-gray-800 text-end pe-5">
                               <span class="text-gray-800 text-hover-primary">
                                 {{ company?.society?.country?.name}}
                               </span>
                       </td>
                     </tr>
                     <tr style="border-bottom: 1px solid #CCCFD3;">
                       <td class="px-5 text-gray-400">{{ $t('company.label.city') }}</td>
                       <td class="text-gray-800 text-end pe-5">
                               <span class="text-gray-800 text-hover-primary"> {{ company?.society?.city}} </span>
                       </td>
                     </tr>
                     <tr style="border-bottom: 1px solid #CCCFD3;">
                       <td class="px-5 text-gray-400">{{ $t('company.label.address') }}</td>
                       <td class="text-gray-800 text-end pe-5">
                               <span class="text-gray-800 text-hover-primary">{{ company?.society?.address}}</span>
                       </td>
                     </tr>
                     <tr style="border-bottom: 1px solid #CCCFD3;">
                       <td class="px-5 text-gray-400">{{ $t('company.label.currency') }}</td>
                       <td class="text-gray-800 text-end pe-5">
                               <span class="text-gray-800 text-hover-primary">
                                 {{ company?.society?.currency_id ? company.society.currency.name + '(' + company.society.currency.iso+ ')' : '' }}
                               </span>
                       </td>
                     </tr>
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
         </div>
         <div class="col-12 col-md-6 col-lg-6">
           <div class="card shadow-sm" style="min-height: 230px;">
             <div class="d-flex flex-wrap py-5">
               <div class="flex-equal">
                 <table class="table fs-6 fw-bold gs-0 gy-2 m-0">
                   <tbody>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.domain') }}</td>
                     <td class="text-gray-800 text-end pe-5">
                       <span class="text-gray-800 text-hover-primary">{{ company?.society?.backoffice_url}}</span>
                     </td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.website') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.website}}</td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.matricule') }}</td>
                     <td class="text-gray-800 text-end pe-5">
                             <span class="text-gray-800 text-hover-primary">{{ company?.society?.ifu_number}}</span>
                     </td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.rccm') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.rccm_number}}</td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.tva') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.tva_number}}</td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.legal_form') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.legal_form}}</td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.headquarters_address') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.headquarters_address}}</td>
                   </tr>
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
 
         </div>
       </div>
     </div>
   </div>
 
   <div class="card" v-show="section == 2">
     <div class="card card-flush pt-3 mb-5 mb-lg-10" data-kt-subscriptions-form="pricing">
       <div class="fs-6 px-10 d-flex flex-wrap py-5">
         <div class="flex-equal">
           <div class="card shadow-sm">
             <div class="d-flex flex-wrap py-5">
               <div class="flex-equal me-5">
                 <table class="table fs-6 fw-bold gs-0 gy-2 gx-2 m-0">
                   <tbody>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.respLastname') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.responsable_lastname}}</td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.respFirstname') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.responsable_firstname}}</td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.respEmail') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.responsable_email}}</td>
                   </tr>
                   <tr style="border-bottom: 1px solid #CCCFD3;">
                     <td class="px-5 text-gray-400">{{ $t('company.label.respPhone') }}</td>
                     <td class="text-gray-800 text-end pe-5">{{ company?.society?.responsable_phone}}</td>
                   </tr>
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 
   <div class="card" v-show="section == 3">
     <div class="card card-flush pt-3 mb-5 mb-lg-10" data-kt-subscriptions-form="pricing">
       <div class="fs-6 px-10 d-flex flex-wrap py-5">
         <div class="flex-equal">
           <div class="card shadow-sm">
             <div class="d-flex flex-wrap py-5">
               <div class="flex-equal me-5">
                 <Card :title="$t('company.label.bankInformation')" containerClass="mb-5">
                   <template #cardToolbar>
                     <div class="d-flex justify-content-end align-items-center">
                       <div v-if="false">
                         <Button type="new" btn-class="btn-sm me-2" v-if="$can(abilities.VIEW_COMPANY)" btn-text="bank.create" @click="openCreateBankModal" ></Button>
                       </div>
                     </div>
                   </template>
                   <template #cardBody>
                     <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="invoices_datatable">
                         <thead class="mb-5">
                           <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                               <th class="min-w-100px text-center">{{ $t('bank.label.accountNumber') }}</th>
                               <th class="min-w-100px text-center">{{ $t('bank.label.accountName') }}</th>
                               <th class="min-w-100px text-center">{{ $t('bank.label.name') }}</th>
                             </tr>
                         </thead>
 
                         <tbody>
                             
                               <tr v-for="account in Object.values(accounts)" :key="account.id">
                                   <td class="text-center">{{ account.account_number }}</td>
                                   <td class="text-center">{{ account.name }}</td>
                                   <td class="text-center">{{ account.bank }}</td>
                               </tr>
                               <tr v-if="Object.values(accounts)?.length === 0">
                                   <td colspan="3" class="text-center">{{ $t('bank.noInformation') }}</td>
                             </tr>
                         </tbody>
                       </table>
                   </template>
                 </Card>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 
   <div class="card" v-show="section == 4">
     <div class="card card-flush pt-3 mb-5 mb-lg-10">
       <div class="d-flex justify-content-end">
         <Button btn-class="btn-sm me-3" type="new" btn-text="button.save" @click.prevent="saveLocation" size="7px 30px" :is-loading="isLoadingLocate"></Button>
       </div>
       <div class="mt-5 px-5">
         <MapComponent v-if="section == 4" @setLocate="getLocate" :latitude="latitude" :longitude="longitude" :address="address"/>
       </div>
     </div>
   </div>
 <!--    <BankCreateModal @loaderBank="loadBankInformation"  id="bank-form-create" :bank="bank"   :isEdit="isEdit"/>-->
   <UpdateSocietyModal
       id="update_society"
       :editForm="editFormData"
       @reloadDatatable="loadCompanyInformation"
   />
 </template>
 
 <script setup>
 import {onMounted, ref, watch} from "vue";
 import {useStore} from "vuex";
 import Button from "@/components/Button.vue";
 import Card from "@/Modules/CRM/components/Card";
 import { computed } from "vue";
 import abilities from "@/composables/abilities";
 import UpdateSocietyModal from "@/components/Office/UpdateSocietyModal.vue";
 import MapComponent from "@/components/MapComponent.vue";
 
 const store = useStore()
 
 const section = ref(1)
 const company = ref({})
 const isLoading = ref(false)
 
 const accounts = computed(() => store.getters['accounts/getAccounts'])
 const currentCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])
 const editFormData = ref({
   name: '',
   society_email: '',
   society_phone_code: '',
   society_phone: '',
   city: '',
   currency_id:'',
   country_id:'',
   zipcode: '',
   address: '',
   headquarters_address: '',
   legal_form: '',
   logo_url: null,
   online: true,
   image_url: null,
   id:""
 })
 
 const isEdit = ref(false);
 const longitude = ref('')
 const latitude = ref('')
 const address = ref('')
 const isLoadingLocate = ref(false)
 
 watch(() => currentCompanyId.value , () => {
   loadCompanyInformation()
   store.dispatch('accounts/loadAccountsForCountry', currentCompanyId.value)
 })
 
 watch(() => company.value , (newValue) => {
   if(newValue) {
     editFormData.value.id = company.value.society.id
     editFormData.value.name = company.value.society.name ?? ''
     editFormData.value.society_email = company.value.society.society_email ?? ''
     editFormData.value.address = company.value.society.address ?? ''
     editFormData.value.country_id = company.value.society.country_id ?? ''
     editFormData.value.currency_id = company.value.society.currency_id ?? ''
     editFormData.value.phone_code = company.value.society.phone_code ?? ''
     editFormData.value.city = company.value.society.city ?? ''
     editFormData.value.zipcode = company.value.society.zipcode ?? ''
     editFormData.value.legal_form = company.value.society.legal_form ?? ''
     editFormData.value.phone = company.value.society.phone ?? ''
     editFormData.value.headquarters_address = company.value.society.headquarters_address ?? ''
     editFormData.value.ifu_number = company.value.society.ifu_number ?? ''
     editFormData.value.rccm_number = company.value.society.rccm_number ?? ''
     longitude.value = company.value.society.longitude ?? ''
     latitude.value= company.value.society.latitude ?? ''
     address.value= company.value.society.address ?? ''
   }
 })
 
 onMounted(() =>{
   loadCompanyInformation()
 })
 
 function getLocate(locate) {
   latitude.value = locate.latitude
   longitude.value = locate.longitude
   address.value = locate.location
 }
 
 function saveLocation() {
   isLoadingLocate.value = true
 
   store.dispatch('multiSociety/updateSociety', {
     ...editFormData.value, 
     longitude: longitude.value, 
     latitude: latitude.value,
     address: address.value
   })
     .then(response => {
       loadCompanyInformation()
       window.toastr.success(t('notification.save_location'))
       isLoadingLocate.value = false;
     })
     .catch(err => {
       isLoadingLocate.value = false;
     });
 }
 
 function toggleEditCompanyInfoForm () {
   editFormData.value.id = company.value.society.id
   editFormData.value.name = company.value.society.name ?? ''
   editFormData.value.society_email = company.value.society.society_email ?? ''
   editFormData.value.address = company.value.society.address ?? ''
   editFormData.value.country_id = company.value.society.country_id ?? ''
   editFormData.value.currency_id = company.value.society.currency_id ?? ''
   editFormData.value.phone_code = company.value.society.phone_code ?? ''
   editFormData.value.city = company.value.society.city ?? ''
   editFormData.value.zipcode = company.value.society.zipcode ?? ''
   editFormData.value.legal_form = company.value.society.legal_form ?? ''
   editFormData.value.phone = company.value.society.phone ?? ''
   editFormData.value.headquarters_address = company.value.society.headquarters_address ?? ''
   editFormData.value.ifu_number = company.value.society.ifu_number ?? ''
   editFormData.value.rccm_number = company.value.society.rccm_number ?? ''
   $('#kt_modal_update_society').modal('toggle');
 }
 
 function changeSection(number) {
   section.value = number
 }
 
 function loadCompanyInformation(){
   isLoading.value = true
   store.dispatch('company/generalInformation').then(resp => {
     company.value = resp?.data
     isLoading.value = false
   }).finally(() => {
     isLoading.value = false
   })
 }
 
 function openCreateBankModal() {
   isEdit.value = false;
   $('#bank-form-create').modal('show');
 }
 </script>
 
 <style scoped>
 
 </style>
 